import { useEffect } from 'react';
export function useDragToScroll(targetRef) {
    useEffect(() => {
        if (!targetRef.current)
            return;
        let isDragging = false;
        const scrollTarget = targetRef.current;
        const position = {
            left: 0,
            x: 0,
        };
        const mouseMoveHandler = (e) => {
            if (!scrollTarget)
                return;
            const dx = e.clientX - position.x;
            scrollTarget.scrollLeft = position.left - dx;
            if (!isDragging) {
                scrollTarget.style.cursor = 'grabbing';
                scrollTarget.style.userSelect = 'none';
            }
            isDragging = true;
        };
        const mouseUpHandler = () => {
            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('mouseup', mouseUpHandler);
            isDragging = false;
            if (!scrollTarget)
                return;
            scrollTarget.style.removeProperty('cursor');
            scrollTarget.style.removeProperty('user-select');
        };
        const mouseDownHandler = (e) => {
            if (!scrollTarget)
                return;
            position.left = scrollTarget.scrollLeft;
            position.x = e.clientX;
            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('mouseup', mouseUpHandler);
        };
        scrollTarget.addEventListener('mousedown', mouseDownHandler);
        /* eslint-disable-next-line consistent-return */
        return () => scrollTarget === null || scrollTarget === void 0 ? void 0 : scrollTarget.removeEventListener('mousedown', mouseDownHandler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [targetRef.current]);
}
//# sourceMappingURL=useDragToScroll.js.map